<template>
	<div>
		<label>{{$t('cart.assignment.accountPicture.title')}}</label>
		<v-alert align="center" outlined block @click="handleAccountPictureUpload" class="mb-4">
			<template v-if="!account?.image && !accountPictureFile">
				<v-icon left size="36">mdi-file-image</v-icon>
				<br>
				<span v-text="$t('cart.assignment.accountPicture.btnDescription')"></span>
			</template>
			<template v-else>
				<v-progress-circular v-if="uploading" indeterminate color="primary" />
				<template v-else>
					<v-icon style="position: absolute; top:10px; right:10px;" size="24"> mdi-pencil</v-icon>
					<img :src="!accountPictureFile ? account.image : accountPictureBase64" style="width: 100px; height: auto; object-fit: cover; border-radius: 4px;" />
					<p class="mb-0" v-if="accountPictureFile && !updateAccountPicture">{{accountPictureFile.name}}</p>
				</template>
			</template>
		</v-alert>
	</div>
</template>

<script>
import { EComService, File } from '@connectngo/sdk';
export default {
	name : 'AccountPictureUpload',

	props: {
		value: {
			type: String,
			default: '',
		},
		account : {
			type: Object,
			default: () => {},
		},
		updateAccountPicture: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		accountPictureFile : null,
		accountPictureBase64 : null,
		uploading : false,
	}),

	computed : {
		_value: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value, 'account_picture')
			},
		},
	},

	methods : {
		handleAccountPictureUpload() {
			File.promptFileDialog(files => {
				const file = files[0];
				if (!file) return;

				const MAX_SIZE_MB = 1.4;
				const MAX_SIZE_PX = 1920;
				const QUALITY = 0.9;

				const processFile = file.size > MAX_SIZE_MB * 1024 * 1024
					? this.resizeImageToBase64(file, MAX_SIZE_PX, QUALITY)
					: File.toBase64(file);

				processFile.then(base64 => {
					this.accountPictureBase64 = base64;
					this.accountPictureFile = file

					this.$emit('accountPictureUpdated', base64)
					if (this.updateAccountPicture) {
						this.uploading = true;
						new EComService().updateAvatar(this.account.id, base64)
							.then(account => {
								this.$snack(this.$i18n.t('editProfileCard.imageUploaded'))
								this.$emit('pictureUploaded', account)
							})
							.catch(reason => {
								this.accountPictureBase64 = null;
								this.accountPictureFile = null;
								this.$handleError(this, reason);
							})
							.finally(() => (this.uploading = false));

					}
				}).catch(error => this.$handleError(this, error));
			}, 'image/*');
		},
		resizeImageToBase64(file, maxSize = 1200, quality = 0.8) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();

				reader.onload = event => {
					const img = new Image();

					img.onload = () => {
						let width = img.width;
						let height = img.height;

						const isPortrait = height > width;

						// Adjust dimensions based on orientation
						if (isPortrait && height > maxSize) {
							width = width * (maxSize / height);
							height = maxSize;
						} else if (!isPortrait && width > maxSize) {
							height = height * (maxSize / width);
							width = maxSize;
						}

						const canvas = document.createElement('canvas');
						canvas.width = width;
						canvas.height = height;

						const ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0, width, height);

						const base64 = canvas.toDataURL('image/jpeg', quality);
						resolve(base64);
					};

					img.onerror = reject;
					img.src = event.target.result;
				};

				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		}
	}
}
</script>